// Data for all location-specific treatment pages
// Each entry maps to a route and renders via <LocationTreatmentPage />

const locationPagesData = {
  /* ─── ACNE ─── */
  'acne-rohini': {
    treatment: 'Acne',
    location: 'Rohini',
    heroClass: 'acnehero',
    heroServiceLabel: 'Acne',
    h1: 'Best Acne Treatment in Rohini | Advanced Pimple and Acne Scar Treatment',
    heroParagraph:
      'Looking for the best acne treatment in Rohini? Get advanced solutions for pimples, acne scars, and oily skin with safe dermatology treatments for clear and healthy skin.',
    h2: 'Best Acne Treatment in Rohini',
    intro: [
      'Acne is one of the most common skin concerns affecting teenagers and adults. Pimples, blackheads, whiteheads, and acne scars can appear due to excess oil production, clogged pores, hormonal changes, or bacterial infection.',
      'If acne is not treated properly, it can lead to long-term skin damage and permanent scarring. Choosing the best acne treatment in Rohini helps control breakouts, reduce inflammation, and restore clear, healthy skin.',
      'Professional skin clinics use advanced techniques and personalized treatment plans to achieve long-lasting results.',
    ],
    sections: [
      {
        h3: 'What Causes Acne?',
        content:
          'Acne develops when hair follicles become clogged with oil and dead skin cells. Several factors may trigger or worsen acne, including:',
        list: [
          'Excess oil production',
          'Hormonal imbalance',
          'Bacterial growth in pores',
          'Poor skincare routine',
          'Stress and lifestyle factors',
          'Certain medications or dietary habits',
        ],
      },
      {
        h3: 'Acne Treatment Options in Rohini',
        content: 'Dermatologists offer several effective treatments based on the type and severity of acne:',
        list: [
          'Topical and oral medications',
          'Chemical peels for skin renewal',
          'Laser therapy to target acne-causing bacteria',
          'Microneedling for acne scars',
          'Hydrafacial for deep pore cleansing',
        ],
      },
      {
        h3: 'Book the Best Acne Treatment in Rohini',
        content:
          'Clear skin is achievable with the right treatment. Choosing the best acne treatment in Rohini ensures you receive personalized dermatological care to address pimples, acne scars, and oily skin effectively.',
      },
    ],
    reviews: [
      {
        text: 'My acne has cleared up significantly after just a few sessions. The doctor was very thorough and professional.',
        author: '— Priya',
      },
      {
        text: 'Amazing results! My scars have faded and my skin looks healthier than it has in years.',
        author: '— Rahul',
      },
      {
        text: 'Very happy with the treatment. The team was knowledgeable and the clinic is very clean.',
        author: '— Simran',
      },
    ],
  },

  /* ─── LASER HAIR REMOVAL ─── */
  'laser-hair-removal-rohini': {
    treatment: 'Laser Hair Removal',
    location: 'Rohini',
    heroClass: 'laserhairhero',
    heroServiceLabel: 'Laser Hair Removal',
    h1: 'Best Laser Hair Removal Treatment in Rohini | Permanent Hair Reduction Clinic',
    heroParagraph:
      'Looking for the best laser hair removal treatment in Rohini? Get safe and advanced laser technology for long-term hair reduction.',
    h2: 'Best Laser Hair Removal Treatment in Rohini',
    intro: [
      'Unwanted body hair is a common concern for both men and women. Traditional methods such as shaving, waxing, and threading often provide only temporary results and may cause irritation, ingrown hair, or skin darkening.',
      'If you are searching for the best laser hair removal treatment in Rohini, advanced cosmetic clinics provide safe and precise laser procedures designed to reduce unwanted hair and improve overall skin smoothness.',
      'Laser hair removal is a popular non-surgical treatment that offers long-term hair reduction with minimal discomfort.',
    ],
    sections: [
      {
        h3: 'Benefits of Laser Hair Removal in Rohini',
        content: 'Choosing the best laser hair removal treatment in Rohini provides several advantages:',
        list: [
          'Long-term reduction in unwanted hair',
          'Smoother and clearer skin',
          'Reduced ingrown hair and razor bumps',
          'Precise treatment that protects surrounding skin',
          'Faster sessions compared to traditional methods',
        ],
      },
      {
        h3: 'How Many Sessions Are Needed?',
        content:
          'Laser hair removal typically requires 4 to 6 sessions or more depending on hair thickness, skin type, and treatment area. Each session gradually reduces hair growth and improves skin smoothness. Maintenance sessions may be recommended to maintain long-term results.',
      },
      {
        h3: 'Book the Best Laser Hair Removal in Rohini',
        content:
          'If you want a reliable and long-term solution for unwanted hair, choosing the best laser hair removal in Rohini can help you achieve smooth, hair-free skin with advanced technology and expert care.',
      },
    ],
    reviews: [
      {
        text: 'I was nervous at first, but the team explained everything clearly and made me feel at ease. Very happy with the progress so far.',
        author: '— Rohan',
      },
      {
        text: "Professional, clean, and effective. The results are better than any other hair removal method I've tried.",
        author: '— Meera',
      },
      {
        text: 'Friendly staff and professional care from start to finish. My skin feels smoother than ever.',
        author: '— Sarah',
      },
    ],
  },

  'laser-hair-removal-shalimar-bagh': {
    treatment: 'Laser Hair Removal',
    location: 'Shalimar Bagh',
    heroClass: 'laserhairhero',
    heroServiceLabel: 'Laser Hair Removal',
    h1: 'Best Laser Hair Removal Treatment in Shalimar Bagh | Permanent Hair Reduction Clinic',
    heroParagraph:
      'Looking for the best laser hair removal treatment in Shalimar Bagh? Get safe and advanced laser technology for long-term hair reduction.',
    h2: 'Best Laser Hair Removal Treatment in Shalimar Bagh',
    intro: [
      'Unwanted body hair is a common concern for both men and women. Laser hair removal offers a modern, effective alternative to temporary methods like shaving and waxing.',
      'If you are searching for the best laser hair removal treatment in Shalimar Bagh, professional cosmetic clinics use advanced laser technology for safe and long-lasting results.',
      'The procedure is non-surgical and suitable for most skin types.',
    ],
    sections: [
      {
        h3: 'Benefits of Laser Hair Removal in Shalimar Bagh',
        content: 'Choosing the best laser hair removal treatment in Shalimar Bagh offers:',
        list: [
          'Long-term reduction in unwanted hair',
          'Smoother skin with reduced ingrown hairs',
          'Precise, skin-safe laser technology',
          'Minimal discomfort and no downtime',
          'Effective for face, underarms, legs, and more',
        ],
      },
      {
        h3: 'Book the Best Laser Hair Removal in Shalimar Bagh',
        content:
          'Achieve smooth, hair-free skin with the best laser hair removal treatment in Shalimar Bagh. Our experienced specialists use advanced technology to deliver safe and lasting results.',
      },
    ],
    reviews: [
      {
        text: 'Great results after just a few sessions. The staff is very professional and the clinic is spotlessly clean.',
        author: '— Nidhi',
      },
      {
        text: "I've tried waxing for years but laser is so much better. Smooth skin and no more ingrown hairs!",
        author: '— Anjali',
      },
      {
        text: 'Highly recommend. The procedure was quick and almost painless. Great value for money.',
        author: '— Rina',
      },
    ],
  },

  'laser-hair-removal-pitampura': {
    treatment: 'Laser Hair Removal',
    location: 'Pitampura',
    heroClass: 'laserhairhero',
    heroServiceLabel: 'Laser Hair Removal',
    h1: 'Best Laser Hair Removal Treatment in Pitampura | Permanent Hair Reduction Clinic',
    heroParagraph:
      'Looking for the best laser hair removal treatment in Pitampura? Get safe and advanced laser technology for long-term hair reduction.',
    h2: 'Best Laser Hair Removal Treatment in Pitampura',
    intro: [
      'Unwanted body hair is a common concern for both men and women. Traditional methods such as shaving, waxing, and threading often provide only temporary results and may cause irritation, ingrown hair, or skin darkening.',
      'If you are searching for the best laser hair removal treatment in Pitampura, advanced cosmetic clinics provide safe and precise laser procedures for long-term hair reduction.',
      'Laser hair removal is a popular non-surgical treatment that offers lasting results with minimal discomfort.',
    ],
    sections: [
      {
        h3: 'Benefits of Laser Hair Removal in Pitampura',
        content: 'Choosing the best laser hair removal treatment in Pitampura provides:',
        list: [
          'Long-term reduction in unwanted hair',
          'Smoother and clearer skin',
          'Reduced ingrown hair and razor bumps',
          'Precise treatment with safe, proven technology',
          'Suitable for face, arms, legs, bikini area, and more',
        ],
      },
      {
        h3: 'Book the Best Laser Hair Removal in Pitampura',
        content:
          'Achieve smooth, hair-free skin with the best laser hair removal treatment in Pitampura. Expert specialists use advanced laser technology to deliver safe and effective results.',
      },
    ],
    reviews: [
      {
        text: 'Fantastic experience. The results are exactly what I hoped for — smooth skin and minimal sessions needed.',
        author: '— Deepa',
      },
      {
        text: 'Very professional and caring team. The laser treatment was comfortable and results are excellent.',
        author: '— Manish',
      },
      {
        text: 'Best decision for hair removal. No more waxing appointments needed!',
        author: '— Pooja',
      },
    ],
  },

  'laser-hair-removal-punjabi-bagh': {
    treatment: 'Laser Hair Removal',
    location: 'Punjabi Bagh',
    heroClass: 'laserhairhero',
    heroServiceLabel: 'Laser Hair Removal',
    h1: 'Best Laser Hair Removal Treatment in Punjabi Bagh | Permanent Hair Reduction Clinic',
    heroParagraph:
      'Looking for the best laser hair removal treatment in Punjabi Bagh? Get safe and advanced laser technology for long-term hair reduction.',
    h2: 'Best Laser Hair Removal Treatment in Punjabi Bagh',
    intro: [
      'Unwanted body hair affects both men and women. Laser hair removal is a modern solution offering long-term results compared to traditional methods.',
      'If you are searching for the best laser hair removal treatment in Punjabi Bagh, professional cosmetic clinics offer precise and safe laser procedures for lasting hair reduction.',
      'The treatment is non-surgical and tailored to individual skin and hair types.',
    ],
    sections: [
      {
        h3: 'Benefits of Laser Hair Removal in Punjabi Bagh',
        content: 'Choosing the best laser hair removal treatment in Punjabi Bagh offers:',
        list: [
          'Long-term hair reduction',
          'Smoother, softer skin',
          'No more razor bumps or ingrown hairs',
          'Safe for multiple body areas',
          'Minimal downtime and fast sessions',
        ],
      },
      {
        h3: 'Book the Best Laser Hair Removal in Punjabi Bagh',
        content:
          'Choose the best laser hair removal in Punjabi Bagh and enjoy lasting smooth skin with safe, advanced technology and personalized expert care.',
      },
    ],
    reviews: [
      {
        text: 'Really impressed with the results. The team is skilled and very professional throughout.',
        author: '— Sonia',
      },
      {
        text: 'The procedure was comfortable and I can already see a significant reduction in hair growth.',
        author: '— Kiran',
      },
      {
        text: 'Excellent clinic with great results. I would strongly recommend this for laser hair removal in Punjabi Bagh.',
        author: '— Anil',
      },
    ],
  },

  /* ─── DERMAL FILLER ─── */
  'dermal-filler-rohini': {
    treatment: 'Dermal Filler',
    location: 'Rohini',
    heroClass: 'fillerhero',
    heroServiceLabel: 'Dermal Filler',
    h1: 'Best Dermal Filler Treatment in Rohini | Volume Restoration and Facial Contouring',
    heroParagraph:
      'Looking for the best dermal filler treatment in Rohini? Restore lost volume, smooth deep lines, and enhance facial contours with safe and natural-looking fillers.',
    h2: 'Best Dermal Filler Treatment in Rohini',
    intro: [
      'As we age, the face gradually loses volume and definition, leading to hollow cheeks, thinning lips, and deepening lines. Dermal fillers offer a non-surgical solution to restore youthful fullness and improve facial contours.',
      'If you are searching for the best dermal filler treatment in Rohini, advanced cosmetic clinics provide customized filler procedures designed to enhance your natural features.',
      'Dermal filler treatments are quick, minimally invasive, and produce immediate results with minimal downtime.',
    ],
    sections: [
      {
        h3: 'What Are Dermal Fillers?',
        content:
          'Dermal fillers are injectable substances, most commonly hyaluronic acid, that restore volume, smooth wrinkles, and enhance facial features. Common treatment areas include:',
        list: [
          'Cheeks and cheekbones',
          'Lips and lip borders',
          'Nasolabial folds (smile lines)',
          'Under-eye hollows (tear trough)',
          'Jawline and chin definition',
          'Temples and forehead',
        ],
      },
      {
        h3: 'Benefits of Dermal Filler Treatment in Rohini',
        content: 'Choosing the best dermal filler treatment in Rohini offers:',
        list: [
          'Immediate volume restoration',
          'Natural-looking enhancement of facial features',
          'Minimally invasive with no surgery required',
          'Quick procedure with little to no downtime',
          'Results lasting 6 to 18 months',
        ],
      },
      {
        h3: 'Book the Best Dermal Filler Treatment in Rohini',
        content:
          'If you want to restore youthful volume and enhance your natural features, choosing the best dermal filler treatment in Rohini ensures safe, customized results from experienced cosmetic specialists.',
      },
    ],
    reviews: [
      {
        text: 'Absolutely love my results. The fillers look so natural and my face looks refreshed and youthful.',
        author: '— Naina',
      },
      {
        text: 'Professional consultation and gentle treatment. The results exceeded my expectations.',
        author: '— Pooja',
      },
      {
        text: 'Excellent clinic and amazing results. The team took time to understand exactly what I wanted.',
        author: '— Reena',
      },
    ],
  },

  'dermal-filler-shalimar-bagh': {
    treatment: 'Dermal Filler',
    location: 'Shalimar Bagh',
    heroClass: 'fillerhero',
    heroServiceLabel: 'Dermal Filler',
    h1: 'Best Dermal Filler Treatment in Shalimar Bagh | Volume Restoration and Facial Contouring',
    heroParagraph:
      'Looking for the best dermal filler treatment in Shalimar Bagh? Restore lost volume and enhance facial contours with safe, natural-looking fillers.',
    h2: 'Best Dermal Filler Treatment in Shalimar Bagh',
    intro: [
      'Facial volume loss is a natural part of ageing. Dermal fillers offer a safe and effective non-surgical way to restore fullness and improve facial contours.',
      'If you are searching for the best dermal filler treatment in Shalimar Bagh, professional cosmetic clinics provide personalized filler treatments tailored to your needs.',
      'Results are immediate and natural-looking with minimal downtime.',
    ],
    sections: [
      {
        h3: 'Benefits of Dermal Filler Treatment in Shalimar Bagh',
        content: 'Choosing the best dermal filler treatment in Shalimar Bagh offers:',
        list: [
          'Immediate volume and contour enhancement',
          'Natural results with hyaluronic acid fillers',
          'Non-surgical with minimal downtime',
          'Customized treatment for cheeks, lips, and more',
          'Results lasting 6 to 18 months',
        ],
      },
      {
        h3: 'Book the Best Dermal Filler Treatment in Shalimar Bagh',
        content:
          'Restore youthful volume and enhance your natural beauty with the best dermal filler treatment in Shalimar Bagh. Our specialists provide safe, personalized filler procedures for outstanding results.',
      },
    ],
    reviews: [
      {
        text: 'My cheeks look fuller and more defined. The results are exactly what I was hoping for.',
        author: '— Meera',
      },
      {
        text: 'Very skilled doctor and comfortable procedure. Highly recommend for fillers in Shalimar Bagh.',
        author: '— Tanya',
      },
      {
        text: 'Professional and clean clinic. The filler results look natural and I get so many compliments.',
        author: '— Asha',
      },
    ],
  },

  'dermal-filler-punjabi-bagh': {
    treatment: 'Dermal Filler',
    location: 'Punjabi Bagh',
    heroClass: 'fillerhero',
    heroServiceLabel: 'Dermal Filler',
    h1: 'Best Dermal Filler Treatment in Punjabi Bagh | Volume Restoration and Facial Contouring',
    heroParagraph:
      'Looking for the best dermal filler treatment in Punjabi Bagh? Restore lost volume, smooth deep lines, and enhance facial contours with safe fillers.',
    h2: 'Best Dermal Filler Treatment in Punjabi Bagh',
    intro: [
      'As we age, the face loses volume and definition. Dermal fillers are a proven non-surgical solution to restore youthful fullness and improve facial contours.',
      'If you are searching for the best dermal filler treatment in Punjabi Bagh, experienced cosmetic specialists offer customized filler procedures for natural-looking results.',
      'Dermal filler treatments are quick, safe, and produce immediate visible improvement.',
    ],
    sections: [
      {
        h3: 'Benefits of Dermal Filler Treatment in Punjabi Bagh',
        content: 'Choosing the best dermal filler treatment in Punjabi Bagh provides:',
        list: [
          'Instant volume restoration',
          'Enhanced lip and cheek definition',
          'Softened nasolabial folds and under-eye hollows',
          'Non-surgical with no recovery time',
          'Long-lasting results of 6 to 18 months',
        ],
      },
      {
        h3: 'Book the Best Dermal Filler Treatment in Punjabi Bagh',
        content:
          'Choose the best dermal filler treatment in Punjabi Bagh to restore youthful volume and enhance your natural features with the expertise of experienced cosmetic specialists.',
      },
    ],
    reviews: [
      {
        text: 'Outstanding results! My face looks refreshed and more youthful without looking overdone.',
        author: '— Seema',
      },
      {
        text: 'The doctor took time to understand my concerns and the results are incredibly natural.',
        author: '— Ritika',
      },
      {
        text: 'Wonderful experience. Very gentle and professional approach. Highly recommended.',
        author: '— Alka',
      },
    ],
  },

  /* ─── PIGMENTATION ─── */
  'pigmentation-rohini': {
    treatment: 'Pigmentation',
    location: 'Rohini',
    heroClass: 'pigmentationhero',
    heroServiceLabel: 'Pigmentation',
    h1: 'Best Pigmentation Treatment in Rohini | Dark Spots and Uneven Skin Tone Clinic',
    heroParagraph:
      'Looking for the best pigmentation treatment in Rohini? Get advanced solutions for dark spots, melasma, and uneven skin tone with safe dermatology treatments.',
    h2: 'Best Pigmentation Treatment in Rohini',
    intro: [
      'Skin pigmentation issues such as dark spots, melasma, sunspots, and uneven skin tone are common concerns for many people. These conditions can affect confidence and overall appearance.',
      'If you are searching for the best pigmentation treatment in Rohini, professional skin clinics offer advanced and safe treatments designed to reduce discolouration and restore even, healthy-looking skin.',
      'Modern dermatology combines targeted therapies to address the root cause of pigmentation for lasting results.',
    ],
    sections: [
      {
        h3: 'Types of Pigmentation Treated',
        content: 'Professional pigmentation treatment in Rohini can address a range of conditions, including:',
        list: [
          'Melasma (hormonal pigmentation)',
          'Sunspots and age spots',
          'Post-inflammatory hyperpigmentation (PIH) from acne',
          'Freckles and uneven skin tone',
          'Dark circles and periorbital pigmentation',
        ],
      },
      {
        h3: 'Pigmentation Treatment Options',
        content: 'Dermatologists offer several effective treatments based on the type and severity of pigmentation:',
        list: [
          'Chemical peels for skin brightening',
          'Laser therapy to target pigmented areas',
          'Microneedling for improved skin texture',
          'Topical depigmenting agents',
        ],
      },
      {
        h3: 'Benefits of Pigmentation Treatment in Rohini',
        content: 'Choosing the best pigmentation treatment in Rohini offers:',
        list: [
          'Visibly reduced dark spots and uneven skin tone',
          'Brighter and more radiant complexion',
          'Improved skin texture and clarity',
          'Personalized treatment plans',
          'Safe procedures with minimal downtime',
        ],
      },
      {
        h3: 'Book the Best Pigmentation Treatment in Rohini',
        content:
          'If you want clearer, more even skin, choosing the best pigmentation treatment in Rohini ensures you receive expert dermatological care tailored to your specific skin concerns.',
      },
    ],
    reviews: [
      {
        text: 'My dark spots have faded significantly after the treatment. Very happy with the results!',
        author: '— Sonali',
      },
      {
        text: 'Excellent care and professional approach. My melasma has improved greatly. Highly recommend.',
        author: '— Rekha',
      },
      {
        text: 'The team took time to understand my skin concerns and the results speak for themselves.',
        author: '— Divya',
      },
    ],
  },
}

export default locationPagesData
